<template>
  <div>
    <div class="bg-primary">
      <div class="container">
        <div class="text-center" v-if="isLoading">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <studentCard :user="user"></studentCard>
        </div>
      </div>
    </div>
    <hr class="space space-sm">

    <div class="container">
      <div class="d-flex aling-items-center justify-content-between">
        <h2 class="h1">Мои предметы</h2>
        <!-- <router-link :to="{ name: 'subjects' }" class="btn btn-light mt-3">Все предметы</router-link> -->
      </div>
      <div class="row" v-if="purchasedSubjects">
        <div class="col-md-12 mb-4" v-for="subject in purchasedSubjects" :key="subject.id">
          <subject-card :subject="subject" :isPurchased="true"></subject-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body p-3 py-5 text-center">
              <p><router-link :to="{ name: 'subjects' }"><img width="48" src="/static/images/icons/plus.svg" alt=""></router-link></p>
              <p><router-link :to="{ name: 'subjects' }" class="btn btn-lg btn-light">Добавить предмет</router-link></p>
            </div>
          </div>
        </div>
      </div>
      <hr class="space space-md">

      <h2 class="h1">Вебинары</h2>
      <p>Ближайшие события</p>
      <div class="row" v-if="webinars">
        <div class="col-md-3 cursor-pointer" v-for="webinar in webinars" :key="webinar.id" @click.prevent="openWebinarModal(webinar)">
          <p><img class="img-fluid" :src="webinar.picture" alt=""></p>
          <p class="semibold truncate mb-0 text-grey fz-sm">Дата и время: {{ webinar.date }}</p>
          <p class="semibold truncate">{{ webinar. title }}</p>
        </div>
      </div>
    </div>
    <webinar-modal ref="modalWebinar" :item="activeWebinar" v-if="activeWebinar"></webinar-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StudentCard from '../Student/Includes/StudentCard'
import SubjectCard from '../Subjects/Includes/SubjectCard'
import WebinarModal from './Includes/WebinarModal'

export default {
  components: {
    studentCard: StudentCard,
    subjectCard: SubjectCard,
    webinarModal: WebinarModal
  },
  data () {
    return {
      show: true,
      year: this.$moment().year(),
      quarter: this.$moment().quarter(),
      activeWebinar: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isLoading: state => state.auth.loading,
      subjects: state => state.students.publicSubjects,
      webinars: state => state.students.publicWebinars
    }),
    purchasedSubjects () {
      if (this.user.subjects) {
        return this.subjects.filter((subject) => {
          return this.user.subjects.includes(subject.slug)
        })
      }
    }
  },
  methods: {
    openEditModal () {
      this.editGroup = null
      setTimeout(() => {
        this.$refs.modal.toggleModal()
      }, 100)
    },
    update () {
      this.$store.dispatch('GET_USER')
      this.$refs.modal.hideModal()
    },
    openWebinarModal (webinar) {
      this.activeWebinar = webinar
      setTimeout(() => {
        this.$refs.modalWebinar.showModal()
      }, 100)
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('SET_LOADING', false)

    setTimeout(() => {
      this.show = false
    }, 2000)
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
    this.$store.dispatch('GET_USER')
    this.$store.dispatch('GET_PUBLIC_SUBJECTS')
    this.$store.dispatch('GET_PUBLIC_WEBINARS')
  }
}
</script>

<style>

</style>
